import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserGroup } from "@fortawesome/pro-regular-svg-icons"
import { Container } from "./styles"

const ManageUsersIcon = ({ color, size }) => (
  <Container color={color} size={size}>
    <FontAwesomeIcon icon={faUserGroup} size={size} />
  </Container>
)

ManageUsersIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
}

ManageUsersIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
}

export default ManageUsersIcon
